 import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ProductService {

	updateFavourite: any;



	constructor(private http: HttpClient) { }

	url1 = environment.serverAPI + "/api/eavattribute";
	url2 = environment.serverAPI4 + '/' + 'api/product/solr';
	url5 = environment.serverAPI4 + '/' + 'api/product/db';
	url6 = environment.serverAPI4 + '/' + 'api/product';
	ur20 = environment.serverAPI9 + '/' + 'api/leadEntity';
	url7 = environment.serverAPI4 + "/api/product/exceltemplate/";
	url8 = environment.serverAPI + "/api/core/exceltemplate/";

	url9 = environment.serverAPI + '/api/core/download/pdf';

	url4 = environment.serverAPI9 + '/' + 'api/leadEntity/db';

	url3 = environment.serverAPI9 + '/' + 'api/leadEntity/solr';

	url10 = environment.serverAPI9 + '/' + 'api/leadEntity';

	url21 = environment.serverAPI9 + '/' + 'api/leadOwnerSearch';

	url11 = environment.serverAPI9 + '/api/housing/leads';

	url22 = environment.serverAPI9 + '/api';

	url = environment.serverAPI2 + "/api/catalog";

	url12 = environment.serverAPI2 + "/api/catalog";

	url13 = environment.serverAPI + "/api/lead/approve";

	url25 = environment.serverAPI9 + '/api';

	getProductByType(page: any, size: any, sort: any, query: any): Observable<Object> {
		query = query != null ? query.split("'").join('') : null;
		let searchQuery = query != null ? query : '';

		const queryParams = `?search=${searchQuery}&page=${page}&size=${size}&sort=${sort}`;

		return this.http.get<Response[]>(`${environment.serverAPI9}/api/posproducts/solr/filter${queryParams}`);
	}

	downloadPdf(fileName): Observable<any> {

		return this.http.get(`${this.url9}?filename=${fileName}`, { responseType: 'arraybuffer', observe: 'response' });

	}


	getProducts(Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url2}?page=${Page}&size=${size}&sort=${sort}`);
	}

	getCustoms(): Observable<Object> {
		return this.http.get(`${this.url1}`);
	}

	addProduct(productEntity): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url6}`, productEntity);
	}
	addOrEditHousingLeadData(housing: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url11}`, housing);
	}

	sendWhatsAppMessage(phoneNumbersList: any, templateId: any): Observable<any> {

		return this.http.post(`${this.url22}/whatsapp/send/message/${templateId}`, phoneNumbersList);
	}

	sendWhatsAppMessageNew(phoneNumbersList: any, templateId: any): Observable<any> {

		return this.http.post(`${this.url22}/whatsapp/message/${templateId}`, phoneNumbersList);
	}

	getProductById(entityId: number): Observable<Object> {
		return this.http.get(`${this.url5}/${entityId}`);
	}

	getProductBySearch(query, Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url6}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
	}

	deleteImage(data: any): Observable<Object> {
		return this.http.post(`${this.url6}/deleteImage`, data);
	}

	productNameVerified(name: any): Observable<Object> {
		return this.http.get(`${this.url1}/admin-api/categoryNameExists/${name}`);
	}

	downloadProductReport(id: any): Observable<any> {
		return this.http.get(`${this.url7}/export/${id}`, { responseType: 'arraybuffer', observe: 'response' });
	}

	downloadProductReportPrimary(Page: number, size: number,
		sort, selectionLead): Observable<any> {
		return this.http.post(`${this.url6}/export/page?page=${Page}
		&size=${size}&sort=${sort}`, selectionLead, {
			responseType: 'arraybuffer',
			observe: 'response'
		});
	}

	excelImportProduct(data: FormData, id: any): Observable<Object> {
		return this.http.post(`${this.url7}/upload/${id}`, data);
	}

	uploadImageZip(data: FormData, id: any, productIds): Observable<Object> {
		return this.http.post(`${this.url8}/upload/zip/${id}?key=${productIds}`, data);
	}

	productNameExists(payload): Observable<any> {
		return this.http.post(`${this.url6}/productNameExists`, payload);
	}
	phonNumberExists(payload): Observable<any> {
		return this.http.post(`${this.ur20}/phonNumberExists`, payload);
	}

	downloadProductTemplate(): Observable<any> {
		return this.http.get(`${this.url6}/update/template/download`, { responseType: 'arraybuffer', observe: 'response' });
	}


	downloadProductNameTemplate(): Observable<any> {
		return this.http.get(`${this.url6}/name/update/template/download`, { responseType: 'arraybuffer', observe: 'response' });
	}

	deleteById(): Observable<Object> {
		return this.http.delete(`${this.url6}`);
	}

	deleteByProductId(id: any): Observable<Object> {
		return this.http.delete(`${this.url6}/${id}`);
	}

	filterByCategoryId(id, fliterlist: any, Page: number, size: number, sort: any): Observable<Object> {

		return this.http.post(`${this.url6}/productsPagination?setId=${id}&page=${Page}&size=${size}&sort=${sort}`, fliterlist);
	}


	configProductFilter(conditon: any, Page: number, size: number, sort: any): Observable<Response[]> {

		let value = {
			condition: conditon
		}
		return this.http.post<Response[]>(`${this.url6}/config/filter?page=${Page}&size=${size}&sort=${sort}`, value);
	}


	deleteByAssociatedProductId(id: any, length: any, productId: any): Observable<Object> {
		return this.http.delete(`${this.url6}/associated/${id}/${length}/${productId}`);
	}


	productNotLinked(linkedProduts, Page: number, size: number, sort: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url6}/linked?page=${Page}&size=${size}&sort=${sort}`, linkedProduts);
	}

	productNotLinkedSearch(linkedProduts, Page: number, size: number, sort: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url6}/linked/search?page=${Page}&size=${size}&sort=${sort}`, linkedProduts);
	}

	downloadGmc(): Observable<any> {
		return this.http.get(`${this.url6}/export/Data`, { responseType: 'arraybuffer', observe: 'response' });
	}

	downloadshopdata() {
		return this.http.get(`${this.url6}/export/ShopprimeData`, { responseType: 'arraybuffer', observe: 'response' });
	}


	getLead(Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url3}?page=${Page}&size=${size}&sort=${sort}`);
	}

	getLeadSelected(Page: any, size: any, sort: any): Observable<Object> {
		return this.http.get(`${this.url3}?page=${Page}&size=${size}&sort=${sort}`);
	}



	deleteByLeadId(id: any): Observable<Object> {
		return this.http.delete(`${this.url10}/${id}`);
	}


	deleteAllLead(): Observable<Object> {
		return this.http.delete(`${this.url10}`);
	}

	deleteBySelectedId(deleteProductist): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url10}/delete/selected`, deleteProductist);
	}


	getLeadBySearch(query, Page: any, size: any, sort: any): Observable<Object> {
		const encodedQuery = query != null ? encodeURIComponent(query) : '';
		return this.http.get(`${this.url10}/filter?search=${encodedQuery}&page=${Page}&size=${size}&sort=${sort}`);
	}


	getLeadOwnerSearch(query, Page: any, size: any, sort: any): Observable<Object> {
		const encodedQuery = query != null ? encodeURIComponent(query) : '';
		return this.http.get(`${this.url21}/filter?search=${encodedQuery}&page=${Page}&size=${size}&sort=${sort}`);
	}

	getLeadOwnerSearchNew(query, Page: any, size: any, sort: any): Observable<Object> {
		const encodedQuery = query != null ? encodeURIComponent(query) : '';
		return this.http.get(`${this.url21}/filter/new?search=${encodedQuery}&page=${Page}&size=${size}&sort=${sort}`);
	}

	searchLeadAdvanceFilter(query: string, page: number, size: number, sort: string, additionalQuery: any): Observable<Response[]> {

		const requestBody = {
			"searchQuery": query,
			"groupBy": null,
			"additionalQuery": additionalQuery

		};

		const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

		return this.http.post<Response[]>(`${this.url10}/filter/advanced${queryParams}`, requestBody);
	}


	getcustomProductValue(values: any): Observable<Object> {
		return this.http.get(`${this.url12}/customProduct?value=${values}`);
	}


	updateLeadStatus(LeadList: any, status: any): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url10}/update/leadStatus/${status}`, LeadList);
	}


	getProductByCategoryId(query): Observable<Object> {

		let payload = {
			"searchQuery": query,
		}
		return this.http.post(`${this.url6}/search/list`, payload);
	}

	getAllProductDropDown(): Observable<Object> {
		return this.http.get(`${this.url2}/dropdown`);
	}

	getPosProductsDropdown(): Observable<Object> {
		return this.http.get(`${this.url2}/dropdown`);
	}

	getAllProductDropDownType(): Observable<Object> {
		return this.http.get(`${this.url2}/type/dropdown`);
	}


	getMissedFollowUp(): Observable<Object> {
		return this.http.get(`${this.url22}/catalog/lead/followupdate/List`);
	}

	getApproved(leadCustomer: any): Observable<Object> {
		return this.http.post(`${this.url13}`, leadCustomer);
	}

	getAllActiveProduct(): Observable<Object> {
		return this.http.get(`${this.url6}/dropdown/active`);
	}



	getAllConnectedOnes(linkedProduts: any, page: number, size: number,
		sort: string): Observable<Response[]> {

		const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

		return this.http.post<Response[]>(`${this.url25}/lead/connectedcalls/new/count${queryParams}`, linkedProduts);
	}


}








